import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { useSelector, useDispatch } from "react-redux";
import { areas } from "../../helpers/areas";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Fab,
  MenuItem,
  InputAdornment,
  Button,
  Grid,
  Typography,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Popover,
  Card,
  CardContent,
} from "@material-ui/core";
import { Print, CreditCard, Save, AssignmentReturn } from "@material-ui/icons";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { CboSeccionales } from "../cbos/CboSeccionales";
import { CboPlanes } from "../cbos/CboPlanes";
import { CboNacionalidades } from "../cbos/CboNacionalidades";
import { CboTipoAfiliacion } from "../cbos/CboTipoAfiliacion";
import { CboConveniosPrestacionales } from "../cbos/CboConveniosPrestacionales";
import { CboMotivosDeBaja } from "../cbos/CboMotivosDeBaja";
import { CboLocalidades } from "../cbos/CboLocalidades";
import { CboProvincias } from "../cbos/CboProvincias";
import { afiliadoStartUpdate, traerPlanYConvenio } from "../../actions/afiliado";
import { CboCategoria } from "../cbos/CboCategoria";
import { guardarAfiliadoNuevo } from "../../actions/preAfiliado/afiliado";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from "react-material-ui-form-validator";
import { CboParentescos } from "../cbos/CboParentescos";
import { changeStepper } from "../../actions/preAfiliado/stepper";
import { BuscadorRnos } from "./BuscadorRnos";
import { startAlerta } from "../../actions/ui/alertas";
import {
  PARENTESCOS,
  TIPO_AFILIACION,
  SEXO,
  TIPO_DOCUMENTO,
  ESTADOS_CIVILES,
  SITUACION_REVISTA,
} from "../../utils/constants";
import { enviarSeguimiento } from "../../actions/afiliado/afiliadoSeguimientoAction";
import ValidatedDatePicker from "../compartidos/ValidatedDatePicker";
import { fetchEmpresasAfiliado } from "../../actions/empresasAfiliado";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { CboMotivosSinFicha } from "../cbos/CboMotivosSinFicha";
import { enviarSinFicha } from "../../actions/afiliado/afiliadoSinFichaAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
  fab: {
    position: "relative",
    top: theme.spacing(2),
    left: theme.spacing(15),
  },
}));

export const PanelDatos = memo((props) => {
  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();





  //manejo de formulario con seleccion
  const { afiliado, consultaAfiliado } = useSelector(
    (state) => state.afiliacion
  );
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);
  const { step } = useSelector((state) => state.stepper);
  const { items } = useSelector((state) => state.localidades);
  const { items: grupoFamiliar } = useSelector((state) => state.grupofamiliar);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSF, setAnchorElSF] = useState(null);

  const openPopSeguimiento = Boolean(anchorEl);
  const idPopSeguimiento = openPopSeguimiento ? "simple-popover" : undefined;

  const openPopSinFicha = Boolean(anchorElSF);
  const idPopSinFicha = openPopSinFicha ? "simple-popover" : undefined;

  const tabConsulta = props.idPanel === "idTabConsulta";
  const tabAfiliacion = props.idPanel === "idTabAfiliacion";
  const tabIngreso = props.idPanel === "idTabIngreso";
  const deshabilitarNacional =
    props.fromBandeja && idAreaUsuario === areas.Nacional;
  const activeId = useRef(afiliado?.id_afiliado);
  const activeIdSitRevista = useRef(afiliado?.id_sit_revista);
  const esUsuarioNacional = useSelector(
    (state) =>
      state.auth.areas.filter((area) => area.idArea === areas.Nacional).length >
      0
  );


  console.log("id area susuario", idAreaUsuario)
  console.log("areas seccional", areas.Seccional)
  console.log(deshabilitarNacional)


  const [
    formValues,
    handleInputChange,
    reset,
    setearValor,
    setearValor2,
    setearValorDomicilio,
    setearValorDomicilio2,
    ,
    setearVariosValores,
  ] = useForm(
    (props.idPanel === "idTabAfiliacion" && afiliado) ||
    (props.idPanel === "idTabConsulta" && consultaAfiliado) ||
    (props.idPanel === "idTabIngreso" && afiliadoEncontrado)
  );

  const {
    apellido_y_nombre,
    carnet,
    parent,
    id_parentesco,
    sexo,
    id_tipo_documento,
    nro_doc,
    fecha_nacimiento,
    id_estado_civil,
    id_nacionalidad,
    cuil,
    id_convenio_prestacional,
    id_plan,
    id_sit_revista,
    id_tipo_afiliacion,
    incapacitado,
    fecha_alta,
    fecha_baja,
    fecha_fin_cobertura,
    id_motivo_baja,
    cuil_familiaracargo,
    domiciliosAfiliados: {
      calle,
      nro,
      piso,
      depto,
      torre,
      circ,
      telefono,
      celular,
      codigo_postal,
      mail,
      id_localidad,
      id_provincia,
      id_seccional,
    },
    rxR,
    judicializado,
    sinFichaAfiliacion,
    fecha_vigencia,
    seguimiento,
    moratoria,
    fecha_origen,
    nro_traspaso,
    rnos,
    fechaAviso,
    observacionSeguimiento,
    id_motivo_SF
  } = formValues;

  // eslint-disable-next-line
  const [stateFechaFinCobertura, setStateFechaFinCobertura] = useState(fecha_fin_cobertura);
  // eslint-disable-next-line
  const [stateFechaNacimiento, setStateFechaNacimiento] = useState(fecha_nacimiento);
  
  const handleClickPopSeguimiento = (event) => {
    setTimeout(setAnchorEl, 2000, event.currentTarget);
  };

  const editarSeguimiento = props.esModificacion
    ? handleClickPopSeguimiento
    : null;

  const handleClosePopSeguimiento = () => {
    setAnchorEl(null);
  };

  const handleClickPopSinFicha = (event) => {
    setTimeout(setAnchorElSF, 2000, event.currentTarget);
  };

  const editarSinFicha = props.esModificacion
    ? handleClickPopSinFicha
    : null;

  const handleClosePopSinFicha = () => {
    setAnchorElSF(null);
  };

  const handleClosePopSinFichaCancelar = () => {
    setearValor("sinFichaAfiliacion", false);
    setAnchorElSF(null);
  };

  const handleSinFichaAdd = (e) => {
    if (id_motivo_SF) {
      e.preventDefault();
      dispatch(enviarSinFicha(id_motivo_SF, true, handleClosePopSinFicha));
    } else {
      dispatch(startAlerta(`Seleccione un motivo`, "warning"));
    }
  };


  const handleSeguimientoAdd = (e) => {
    e.preventDefault();
    //if(seguimiento === true){
    dispatch(enviarSeguimiento(observacionSeguimiento, fechaAviso, true));
    //}
  };

  const handleClickImprimirConstancia = (e) => {
    e.preventDefault();
    if (id_parentesco === 0 && !moment(fecha_baja).isValid()) {
      props.setAbrirConstancia(true);
    } else {
      dispatch(startAlerta(`Solo Titulares de alta`, "info"));
    }
  };

  const handleDateChangeFechaVigencia = (date) => {
    setearValor("fecha_vigencia", date);
  };

  const handleChangeCboTipoAfiliacion = (e) => {
    handleInputChange(e);
  };

  const handleLocalidadChange = (e) => {
    if (items?.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearValorDomicilio2(
        "id_provincia",
        localidad.id_provincia,
        "id_localidad",
        localidad.id_localidad,
        "id_seccional",
        localidad.id_seccional
      );
    }
  };


  const handleCPChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    const cp = e.target.value;
    if (cp === "" || reg.test(cp)) {
      const listaFiltrada = items.filter(loc => cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(cp));
      if (listaFiltrada?.length > 0) {
        const localidad = listaFiltrada[0];
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: localidad?.id_provincia,
            id_localidad: localidad?.id_localidad,
            id_seccional: localidad?.id_seccional
          }
        });
      } else {
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: "",
            id_localidad: "",
            id_seccional: ""
          }
        });
      }
    }
  };
  console.log(formValues.domiciliosAfiliados);
  const handleInputDomicilio = (e) => {
    setearValorDomicilio(e.target.name, e.target.value);
  };

  const onChangeDiscapacidadHandler = (e) => {
    setearValor("incapacitado", e.target.value);

    if (!!e.target.value) {
      props.setEsDiscapacitado(true);
    } else {
      props.setEsDiscapacitado(false);
    }
  };

  const handleSaveClick = (idPanel) => {
    document.querySelector(`#btnsubmit`).click();
  };

  const handleChangeCheckbox = (e) => {
    setearValor(e.target.name, e.target.checked);
    if (e.target.name === "seguimiento" && e.target.checked) {
      setAnchorEl(e.currentTarget);
    } else if (e.target.name === "sinFichaAfiliacion") {
      if (e.target.checked) {
        setAnchorElSF(e.currentTarget);
      } else {
        handleClosePopSinFicha();
        dispatch(enviarSinFicha(null, false, handleClosePopSinFicha));
      }
    }
  };

  const handleChangeValid = (e) => {
    if (e.target.value === TIPO_DOCUMENTO.RN) {
      setearValor2(
        "fecha_fin_cobertura",
        moment(fecha_nacimiento).add(1, "M"),
        "id_tipo_documento",
        e.target.value
      );
    } else {
      setearValor2(
        "fecha_fin_cobertura",
        null,
        "id_tipo_documento",
        e.target.value
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (props.idTabIngreso === "idTabTitularModi") {
      dispatch(guardarAfiliadoNuevo(formValues));
      // dispatch(actualizarDatosPersonales())
      dispatch(changeStepper(step + 1));
    }
    if (
      props.idPanel === "idTabIngreso" &&
      props.idTabIngreso !== "idTabTitularModi"
    ) {
      dispatch(guardarAfiliadoNuevo(formValues));
      // dispatch(actualizarDatosPersonales())
      dispatch(changeStepper(step + 1));
    } else {
      if (props.idTabIngreso !== "idTabTitularModi") {
        dispatch(afiliadoStartUpdate(formValues, "", props.esReactivacion));
      }
    }
  };

  // eslint-disable-next-line
  const [edad, setEdad] = useState(
    moment().diff(moment(fecha_nacimiento), "years", false)
  );

  
  useEffect(() => {
    if (afiliado?.id_plan === null || afiliado?.id_plan === undefined)
      dispatch(traerPlanYConvenio(afiliado?.id_afiliado));
  }, [afiliado]);

  //si cambia de afiliado seleccionado cargo formulario nuevamente
  // eslint-disable-next-line
  useEffect(() => {
    if (afiliado && afiliado.id_afiliado !== activeId.current) {
      reset(afiliado);
      setEdad(
        moment().diff(moment(afiliado?.fecha_nacimiento), "years", false)
      );
      activeId.current = afiliado.id_afiliado;
    }
  }, [afiliado, reset]);

  // eslint-disable-next-line
  useEffect(() => {
    if (afiliado && afiliado.id_sit_revista !== activeIdSitRevista.current) {
      dispatch(fetchEmpresasAfiliado(afiliado?.id_afiliado));
    }
    // eslint-disable-next-line
  }, [afiliado]);


  // eslint-disable-next-line
  useEffect(() => {

    //Motivo baja
    ValidatorForm.addValidationRule("motivoBajaValido", (value) => {
      if ((moment(fecha_baja).isValid() && !props.esReactivacion) || moment(fecha_fin_cobertura).isValid()) {
        if (moment(value).isValid()) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }

    });


    //Fecha BAJA
    ValidatorForm.addValidationRule("isBeforeFechaVigencia", (value) => {
      if (
        moment(value).isValid() &&
        moment(value).isBefore(moment(fecha_vigencia))
      ) {
        return false;
      }
      return true;
    });

    //Fecha FIN COBERTURA
    ValidatorForm.addValidationRule("isRequiredByTipoAfi", (value) => {
      if (
        (id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO ||
          id_tipo_afiliacion === TIPO_AFILIACION.PASANTE) &&
        !moment(value).isValid()
      ) {
        return false;
      }
      return true;
    });

    //Fecha FIN COBERTURA
    ValidatorForm.addValidationRule("isAfterFechaCobertura", (value) => {
      if (moment(fecha_vigencia).isAfter(moment(value), "day")) {
        return false;
      }
      return true;
    });

    //Fecha FIN COBERTURA
    ValidatorForm.addValidationRule("isRequiredByTipoAfi2", (value) => {
      if (
        (id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO ||
          id_tipo_afiliacion === TIPO_AFILIACION.PASANTE) &&
        !moment(value).isValid() &&
        !(
          props.idPanel === "idTabConsulta" ||
          props.fromBandejaFamiliar ||
          (props.fromBandeja && idAreaUsuario === areas.Nacional)
        )
      ) {
        return false;
      }
      return true;
    });

    ValidatorForm.addValidationRule("fechaCoberturaMenorAHoy", (value) => {
      if (moment(value).isValid() && tabIngreso) {
        if (new Date() > moment(value))
          return false;
      }
      return true;
    });

    //CUIL FAMILIAR A CARGO
    ValidatorForm.addValidationRule("isNotGrupoFamiliar", (value) => {
      const arrayCoincideCuil = grupoFamiliar.filter(

        (familiar) => familiar.cuil === parseInt(value)

      );
      return arrayCoincideCuil.length > 0
    });
  });

  //VALIDACIONES
  const emailValidators =
    moment(fecha_baja).isValid() && id_motivo_baja > 0
      ? ["isEmail"]
      : ["required", "isEmail"];

  const emailErrorMessage =
    moment(fecha_baja).isValid() && id_motivo_baja > 0
      ? ["Email invalido"]
      : ["El EMail es requerido", "Email invalido"];

  const calleValidator =
    moment(fecha_baja).isValid() && id_motivo_baja > 0
      ? ["isString"]
      : ["required"];

  const calleErrorMessage =
    moment(fecha_baja).isValid() && id_motivo_baja > 0
      ? ["Debe ser una cadena de texto"]
      : ["La calle es requerida"];

  // const numeroValidator =
  //   moment(fecha_baja).isValid() && id_motivo_baja > 0
  //     ? ["isNumber"]
  //     : ["required", "minNumber:1", "maxNumber:99999"];

  // const numeroErrorMessage =
  //   moment(fecha_baja).isValid() && id_motivo_baja > 0
  //     ? ["Debe ser un número"]
  //     : [
  //         "El numero es requerido",
  //         "El número debe ser mayor a 0",
  //         "El número debe ser menor a 100.000",
  //       ];

  const validadoresTelefono =
    celular?.length === 10 ||
      (moment(fecha_baja).isValid() && id_motivo_baja > 0)
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageTelefono =
    celular?.length === 10 ||
      (moment(fecha_baja).isValid() && id_motivo_baja > 0)
      ? ["Solo numeros", "Verifique su telefono", "Verifique su telefono"]
      : [
        "El telefono es requerido",
        "Solo numeros",
        "Verifique su telefono",
        "Verifique su telefono",
      ];

  const validadoresCelular =
    telefono?.length === 10 ||
      (moment(fecha_baja).isValid() && id_motivo_baja > 0)
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageCelular =
    telefono?.length === 10 ||
      (moment(fecha_baja).isValid() && id_motivo_baja > 0)
      ? ["Solo numeros", "Verifique su celular", "Verifique su celular"]
      : [
        "El celular es requerido",
        "Solo numeros",
        "Verifique su celular",
        "Verifique su celular",
      ];

  const esFechaBajaRequerida =
    fecha_fin_cobertura === null &&
    !moment(fecha_fin_cobertura).isValid() &&
    id_motivo_baja !== null &&
    id_motivo_baja > 0;

  /*const esMotivoBajaRequerido = moment(fecha_baja).isValid();*/

  const esMotivoBajaRequerido = (moment(fecha_baja).isValid() && !props.esReactivacion) || moment(fecha_fin_cobertura).isValid();

  const onChangeDNIHandler = (event) => {
    if (!tabIngreso) {
      if (
        event.target.value.trim().length === 9 &&
        cuil.toString().trim().length === 11
      ) {
        setearValor("cuil", "");
      }
    }
  };

  const onChangeCuildHandler = (event) => {
    if (!tabIngreso) {
      if (
        event.target.value.trim().length === 12 &&
        nro_doc.toString().trim().length === 8
      ) {
        setearValor("nro_doc", "");
      }
    }
  };
  console.log(afiliado.nro_doc)
  console.log(props.esModificacion && id_nacionalidad === 10 && esUsuarioNacional && (afiliado.nro_doc !== 0))

  return (
    <>
      <ValidatorForm onSubmit={handleSubmit}>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <TextField
                margin="normal"
                InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                disabled={true}
                label="Nro. Afiliado"
                name="carnet"
                value={`${carnet || ""}/${parent || ""}`}
                autoComplete="off"
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={3}>
              <CboParentescos
                manejadorInputChange={handleInputChange}
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                valor={id_parentesco}
                name="id_parentesco"
                idPanel={props.idPanel}
                grupoFamiliar={grupoFamiliar}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                fullWidth
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Apellido y Nombre"
                name="apellido_y_nombre"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                value={apellido_y_nombre || ""}
                autoComplete="off"
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={"auto"}>
              <SelectValidator
                value={sexo || ""}
                disabled={
                  /* props.esReactivacion || props.esModificacion
                    ? true
                    : */ (tabConsulta && !props.esReactivacion) ||
                    props.fromBandejaFamiliar ||
                    deshabilitarNacional
                    ? true
                    : false
                }
                onChange={(e)=>{
                    if (e.target.value === SEXO.NO_INFORMADO) dispatch(startAlerta("El sexo NO INFORMADO no se encuentra permitido", "error", "Error"))
                    else setearValor("sexo", e.target.value)
                  }
                }
                label="Sexo"
                name="sexo"
                validators={["required"]}
                errorMessages={["El sexo es requerido"]}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  shrink: true,
                }}
                fullWidth={true}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={SEXO.MASCULINO}>M</MenuItem>
                <MenuItem value={SEXO.FEMENINO}>F</MenuItem>
                <MenuItem value={SEXO.NO_INFORMADO}>N</MenuItem>
                <MenuItem value={SEXO.NO_BINARIO}>X</MenuItem>
              </SelectValidator>
            </Grid>
            <Grid item xs={1}>
              <SelectValidator
                value={id_tipo_documento || ""}
                disabled={
                  props.esReactivacion
                    ? true
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      (tabAfiliacion &&
                        id_parentesco === PARENTESCOS.TITULAR) ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                label="Tip.Doc"
                name="id_tipo_documento"
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
                margin="normal"
                fullWidth={true}
                onChange={handleChangeValid}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.DNI}>DNI</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO}>
                  LE
                </MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.LIBRETA_CIVICA}>LC</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.PASAPORTE}>PAS</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.NI}>NI</MenuItem>
                {afiliado.id_parentesco !== PARENTESCOS.TITULAR && (
                  <MenuItem value={TIPO_DOCUMENTO.RN}>RN</MenuItem>
                )}
              </SelectValidator>
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                fullWidth
                label="Nro. Doc."
                name="nro_doc"
                value={nro_doc || ""}
                disabled={
                  props.esReactivacion || (props.esModificacion && id_nacionalidad === 10 && esUsuarioNacional && (afiliado.nro_doc !== 0))
                    ? true
                    : tabConsulta ||
                      props.fromBandeja ||
                      props.fromBandejaFamiliar ||
                      (tabIngreso && id_parentesco === PARENTESCOS.TITULAR && !esUsuarioNacional && (afiliadoEncontrado.nro_doc !== 0)) 
                      ? true
                      : false
                     
                    }
                autoComplete="off"
                onChange={(e) => {
                  handleInputChange(e);
                  onChangeDNIHandler(e);
                }}
                validators={["required", "isNumber", "maxNumber:99999999"]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su dni",
                ]}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                fullWidth
                label="CUIL"
                name="cuil"
                value={cuil || ""}
                autoComplete="off"
                disabled={
                  props.esReactivacion || (props.esModificacion && id_nacionalidad === 10 && esUsuarioNacional && (afiliado.nro_doc !== 0)) 
                    ? true
                    : tabConsulta ||
                      (tabIngreso && afiliadoEncontrado.nro_doc !== 0)
                      ? true
                      : false
                }
                onChange={(e) => {
                  handleInputChange(e);
                  onChangeCuildHandler(e);
                }}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999999",
                  "minNumber:9999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su cuil",
                  "Verifique su cuil",
                ]}
              />
            </Grid>
            <Grid item xs>
              <SelectValidator
                value={id_estado_civil || ""}
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={(e) => {
                  handleInputChange(e);
                }}
                label="Est.Civil"
                name="id_estado_civil"
                validators={["required"]}
                errorMessages={["El estado es requerido"]}
                fullWidth={true}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.CASADO}>CASADO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.SOLTERO}>SOLTERO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.SEPARADO}>SEPARADO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.DIVORCIADO}>
                  DIVORCIADO/A
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.VIUDO}>VIUDO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.CONCUBINO}>
                  CONCUBINO/A
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.OTRO}>OTRO</MenuItem>
              </SelectValidator>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fec. Nac."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  maxDate={new Date()} //maxDate
                  minDate={
                    (id_parentesco === PARENTESCOS.HIJO_MENOR &&
                      moment().subtract("year", 22)) ||
                    (id_parentesco === PARENTESCOS.HIJO_ESTUDIANTE &&
                      moment().subtract("year", 27)) ||
                    moment().subtract("year", 200)
                  }
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={
                    props.esReactivacion
                      ? false
                      : tabConsulta ||
                        props.fromBandejaFamiliar ||
                        deshabilitarNacional
                        ? true
                        : false
                  }
                  value={stateFechaNacimiento}
                  minDateMessage={`La fecha no debe ser anterior a la fecha mínima`}
                  onChange={(date) => {
                    setStateFechaNacimiento(date)
                    setearValor("fecha_nacimiento", date);
                    setEdad(moment().diff(moment(date), "years", false));
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["isValidDate"]}
                  errorMessages={["La fecha ingresada no es valida"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                fullWidth
                label="Edad"
                value={`${edad || ""} Años`}
                autoComplete="off"
                disabled={true}
              />
            </Grid>
            <Grid item xs={2}>
              <CboNacionalidades
                manejadorInputChange={handleInputChange}
                valor={id_nacionalidad}
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                idPanel={props.idPanel}
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={mail || ""}
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                label="EMail"
                name="mail"
                autoComplete="off"
                fullWidth
                validators={emailValidators}
                errorMessages={emailErrorMessage}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={telefono || ""}
                onChange={handleInputDomicilio}
                label="Teléfono(10 dígitos sin 0)"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                name="telefono"
                autoComplete="off"
                maxLength="10"
                validators={validadoresTelefono}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">0</InputAdornment>
                  ),
                }}
                errorMessages={errorMessageTelefono}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={celular || ""}
                onChange={handleInputDomicilio}
                label="Celular(10 dígitos sin 0 ni 15)"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                name="celular"
                maxLength="10"
                autoComplete="off"
                validators={validadoresCelular}
                errorMessages={errorMessageCelular}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                value={calle || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Calle"
                name="calle"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
                validators={calleValidator}
                errorMessages={calleErrorMessage}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={nro || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Numero"
                name="nro"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              //validators={numeroValidator}
              //errorMessages={numeroErrorMessage}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={piso || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Piso"
                name="piso"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={depto || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Depto."
                name="depto"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={torre || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Torre"
                name="torre"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={circ || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Circ"
                name="circ"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid container item xs={5} justify="center">
              <Grid item container justify="center">
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="rxR"
                        disabled={
                          props.esReactivacion
                            ? false
                            : tabConsulta ||
                              props.fromBandejaFamiliar ||
                              deshabilitarNacional
                              ? true
                              : false
                        }
                        checked={rxR}
                        onChange={handleChangeCheckbox}
                      />
                    }
                    label="Rama por Reunión"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="judicializado"
                        disabled={
                          props.esReactivacion
                            ? false
                            : tabConsulta ||
                              idAreaUsuario === areas.Seccional ||
                              props.fromBandejaFamiliar ||
                              deshabilitarNacional
                              ? true
                              : false
                        }
                        checked={judicializado}
                        onChange={handleChangeCheckbox}
                      />
                    }
                    label="Judicializado"
                  />
                  <FormControlLabel
                    style={{
                      cursor: props.esModificacion ? "auto" : "default",
                    }}
                    control={
                      <Fragment>
                        <Checkbox
                          name="seguimiento"
                          aria-describedby={idPopSeguimiento}
                          disabled={
                            props.esReactivacion
                              ? false
                              : tabConsulta ||
                                idAreaUsuario === areas.Seccional ||
                                props.fromBandejaFamiliar ||
                                deshabilitarNacional
                                ? true
                                : false
                          }
                          checked={seguimiento}
                          onChange={handleChangeCheckbox}
                        />
                        <Typography
                          onMouseOver={
                            seguimiento === true ? editarSeguimiento : null
                          }
                          style={{
                            color:
                              props.esModificacion || props.esReactivacion
                                ? "black"
                                : "#bebebe",
                          }}
                        >
                          Seguimiento
                        </Typography>
                      </Fragment>
                    }
                  ></FormControlLabel>
                  <Popover
                    id={idPopSeguimiento}
                    open={openPopSeguimiento}
                    onClose={handleClosePopSeguimiento}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "left",
                    }}
                    PaperProps={{
                      style: { width: "200px", height: "250px" },
                    }}
                  >
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                          gutterBottom
                        >
                          Aviso de Seguimiento
                        </Typography>
                        <TextField
                          id="txtFechaSeguimiento"
                          name="fechaAviso"
                          label="Fecha Aviso"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          inputProps={{
                            shrink: true,
                            min: moment(new Date())
                              .format("YYYY-MM-DD")
                              .toString(),
                          }}
                          value={moment(fechaAviso).format("YYYY-MM-DD") || ""}
                          className={classes.textField}
                          onChange={handleInputChange}
                        />
                        <TextField
                          id="txtmensajeSeguimiento"
                          name="observacionSeguimiento"
                          placeholder="Ingrese Mensaje"
                          multiline
                          onChange={handleInputChange}
                          value={observacionSeguimiento}
                        />
                        <Fab
                          className={classes.fab}
                          size="small"
                          onClick={handleSeguimientoAdd}
                          color="primary"
                          aria-label="add"
                        >
                          <AssignmentReturn />
                        </Fab>
                      </CardContent>
                      {/* <CardActions>
                        <Fab 
                          size="small"  
                          onClick={(e) => handleSaveSeguimiento(e)} 
                          color="secondary" 
                          aria-label="add" 
                          className={classes.margin}
                        >
                          <AddIcon />
                        </Fab>
                      </CardActions> */}
                    </Card>
                  </Popover>
                  <FormControlLabel
                    control={
                      <Fragment>
                        <Checkbox
                          name="sinFichaAfiliacion"
                          aria-describedby={idPopSinFicha}
                          disabled={
                            props.esReactivacion
                              ? false
                              : tabConsulta ||
                                idAreaUsuario === areas.Seccional ||
                                props.fromBandejaFamiliar ||
                                deshabilitarNacional
                                ? true
                                : false
                          }
                          checked={sinFichaAfiliacion}
                          onChange={handleChangeCheckbox}
                        />
                        <Typography
                          onMouseOver={
                            sinFichaAfiliacion === true ? editarSinFicha : null
                          }
                          style={{
                            color:
                              props.esModificacion || props.esReactivacion
                                ? "black"
                                : "#bebebe",
                          }}
                        >
                          Sin Ficha
                        </Typography>
                      </Fragment>
                    }
                  />
                  <Popover
                    id={idPopSinFicha}
                    open={openPopSinFicha}
                    onClose={handleClosePopSinFicha}
                    anchorEl={anchorElSF}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "left",
                    }}
                    PaperProps={{
                      style: { width: "200px", height: "250px" },
                    }}
                    disableBackdropClick={true}
                  >
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                          gutterBottom
                        >
                          Motivo Sin Ficha
                        </Typography>
                        <CboMotivosSinFicha
                          manejadorInputChange={handleInputChange}
                          valor={id_motivo_SF}
                          disabled={false}
                          idPanel={props.idPanel}
                          required={true}
                          validators={["motivoSinFichaValido"]}
                          errorMessages={[
                            "Debe ingresar motivo",
                          ]}
                        />
                        <Fab
                          className={classes.fab}
                          size="small"
                          onClick={handleSinFichaAdd}
                          color="primary"
                          aria-label="add"
                        >
                          <AssignmentReturn />
                        </Fab>
                        <Button
                          variant="contained"
                          color="secundary"
                          size="small"
                          onClick={() => handleClosePopSinFichaCancelar()}
                          className={classes.button}
                          style={{ marginLeft: '-35px', marginTop: '25px' }}
                          //startIcon={<Save />}
                        >
                          Cancelar
                        </Button>
                      </CardContent>
                      {/* <CardActions>
                        <Fab 
                          size="small"  
                          onClick={(e) => handleSaveSeguimiento(e)} 
                          color="secondary" 
                          aria-label="add" 
                          className={classes.margin}
                        >
                          <AddIcon />
                        </Fab>
                      </CardActions> */}
                    </Card>
                  </Popover>




                  {
                    (id_sit_revista === SITUACION_REVISTA.MONOTRIBUTISTA || id_sit_revista === SITUACION_REVISTA.MONOTRIBUTISTA_SOCIAL) && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="moratoria"
                            disabled={
                              props.esReactivacion
                                ? false
                                : tabConsulta ||
                                  idAreaUsuario === areas.Seccional ||
                                  props.fromBandejaFamiliar ||
                                  deshabilitarNacional
                                  ? true
                                  : false
                            }
                            checked={moratoria}
                            onChange={handleChangeCheckbox}
                          />
                        }
                        label="Moratoria"
                      />
                    )
                  }
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
          {/* Division */}
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={codigo_postal || ""}
                onChange={handleCPChange}
                label="Cod. Postal"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                name="codigo_postal"
                inputProps={{ maxLength: 4 }}
                autoComplete="off"
                validators={["required"]}
                errorMessages={["El codigo postal es requerido"]}
              />
            </Grid>
            <Grid item xs={2}>
              <CboLocalidades
                manejadorInputChange={(e) => {
                  handleInputDomicilio(e);
                  handleLocalidadChange(e);
                }}
                name="id_localidad"
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                valor={id_localidad}
                cp={codigo_postal}
                idPanel={props.idPanel}
              />
            </Grid>
            <Grid item xs={2}>
              <CboProvincias
                manejadorInputChange={handleInputDomicilio}
                valor={id_provincia}
                name="id_provincia"
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={2}>
              <CboSeccionales
                manejadorInputChange={handleInputDomicilio}
                valor={id_seccional}
                name="id_seccional"
                disabled
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={1}>
              <CboConveniosPrestacionales
                manejadorInputChange={handleInputChange}
                valor={tabIngreso ? 1 : id_convenio_prestacional}
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={1}>
              <CboPlanes
                manejadorInputChange={handleInputChange}
                valor={tabIngreso ? 1 : id_plan}
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={3}>
              <Grid container>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider
                    locale={esLocale}
                    utils={DateFnsUtils}
                  >
                    <KeyboardDatePicker
                      margin="normal"
                      id="dialogFecha_origen"
                      label="Fec. Origen"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      maxDate={new Date()} //maxDate
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        shrink: true,
                        min: moment(new Date()).format("YYYY-MM-DD").toString(),
                      }}
                      disabled={true}
                      //cuando es preafi se muestra fecha_alta del registro de stage
                      value={
                        moment(fecha_origen).isValid()
                          ? moment(fecha_origen)
                          : moment(fecha_alta).isValid()
                            ? moment(fecha_alta)
                            : null
                      }
                      // onChange={(date) => {
                      //   setearValor("fecha_origen", date);
                      // }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider
                    locale={esLocale}
                    utils={DateFnsUtils}
                  >
                    <KeyboardDatePicker
                      margin="normal"
                      id="dialogFecha_vigencia"
                      label="Fec. Vigencia"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      required={tabConsulta ? false : true}
                      maxDate={moment(new Date()).add(3, "M")} //maxDate
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      disabled={
                        props.esReactivacion
                          ? false
                          : tabConsulta ||
                          idAreaUsuario === areas.Seccional ||
                          props.fromBandejaFamiliar
                      }
                      value={
                        moment(fecha_vigencia).isValid()
                          ? moment(fecha_vigencia)
                          : null
                      }
                      onChange={(date) => {
                        handleDateChangeFechaVigencia(date);
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Division */}
          <Grid container spacing={1}>
            {!(id_parentesco > 0) && (
              <Fragment>
                <Grid item xs={1}>
                  <CboCategoria
                    manejadorInputChange={handleInputChange}
                    fromBandejaFamiliar={props.fromBandejaFamiliar}
                    fromBandeja={props.fromBandeja}
                    valor={id_sit_revista}
                    parentesco={id_parentesco}
                    idPanel={props.idPanel}
                    reactivacion={props.esReactivacion}
                  />
                </Grid>
                <Grid item xs={2}>
                  <CboTipoAfiliacion
                    manejadorInputChange={(e) => {
                      handleChangeCboTipoAfiliacion(e);
                    }}
                    valor={id_tipo_afiliacion}
                    parentesco={id_parentesco}
                    fromBandejaFamiliar={props.fromBandejaFamiliar}
                    idCategoria={id_sit_revista}
                    fromBandeja={props.fromBandeja}
                    idPanel={props.idPanel}
                    reactivacion={props.esReactivacion}
                    setearVariosValores={setearVariosValores}
                    tabIngreso={tabIngreso}
                    esModificacion={props.esModificacion}
                    fechaBaja={moment(fecha_baja).isValid()}
                  />
                </Grid>
              </Fragment>
            )}
            <Grid item xs={1}>
              <SelectValidator
                value={incapacitado || 0}
                name="incapacitado"
                disabled={
                  props.esReactivacion
                    ? false
                    : tabConsulta ||
                      props.fromBandejaFamiliar ||
                      deshabilitarNacional
                      ? true
                      : false
                }
                onChange={onChangeDiscapacidadHandler}
                label="Discap."
                margin="normal"
                fullWidth={true}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={0}>NO</MenuItem>
                <MenuItem value={1}>SI</MenuItem>
              </SelectValidator>
            </Grid>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFechaAlta"
                  label="Fecha de Alta"
                  maxDate={new Date()} //maxDate
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={true}
                  value={
                    moment(fecha_alta).isValid()
                      ? moment(fecha_alta)
                      : moment(new Date())
                  }
                  onChange={(date) => {
                    setearValor("fecha_alta", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  margin="normal"
                  id="dialogFecFin"
                  label="Fecha Fin Cobertura"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  /*Cambiado a pedido del area de Afiliaciones (en contra de las recomendaciones del equipo de desarrollo).
                  Ahora esta habilitado todo el tiempo para reactivaciones
                  disabled={
                   ((props.esReactivacion || tabIngreso) && (id_tipo_afiliacion === TIPO_AFILIACION.PASANTE 
                    || id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO 
                    || id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO_CON_CUOTA))
                    && !deshabilitarNacional
                      ? false
                      : tabIngreso || tabConsulta || props.fromBandejaFamiliar || deshabilitarNacional ? true : false 
                    }
                    */
                  disabled={
                    ((tabIngreso && (id_tipo_afiliacion === TIPO_AFILIACION.PASANTE
                      || id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO
                      || id_tipo_afiliacion === TIPO_AFILIACION.TEMPORARIO_CON_CUOTA))
                      && !deshabilitarNacional) || props.esReactivacion
                      ? false
                      : tabIngreso || tabConsulta || props.fromBandejaFamiliar || deshabilitarNacional ? true : false
                  }
                  value={stateFechaFinCobertura}
                  onChange={date => {
                    setStateFechaFinCobertura(date)
                    setearValor("fecha_fin_cobertura", date)
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={[
                    "isRequiredByTipoAfi",
                    "isAfterFechaCobertura",
                    "isRequiredByTipoAfi2",
                    "fechaCoberturaMenorAHoy",
                    "isValidDate"
                  ]}
                  errorMessages={[
                    "Fecha Fin Obligatoria",
                    "Fecha Vigencia debe ser menor a Fecha Fin Cobertura",
                    "Fecha Fin Obligatoria",
                    "La fecha no puede ser anterior a la fecha actual",
                    "La fecha ingresada no es valida"
                  ]}
                  minDate={new Date()}
                  minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  margin="normal"
                  id="dialogFechaBaja"
                  label="Fecha de Baja"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={
                    props.esReactivacion
                      ? false
                      : tabConsulta ||
                        tabIngreso ||
                        idAreaUsuario === areas.Seccional ||
                        deshabilitarNacional ||
                        moment(afiliado?.fecha_baja).isValid()
                        ? true
                        : false
                  }
                  maxDate={new Date()} //maxDate
                  value={
                    moment(fecha_baja).isValid() ? moment(fecha_baja) : null
                  }
                  onChange={(date) => {
                    setearValor("fecha_baja", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  required={esFechaBajaRequerida}
                  validators={["isBeforeFechaVigencia"]}
                  errorMessages={[
                    "La fecha de baja debe ser mayor a la fecha de vigencia",
                  ]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2}>
              <CboMotivosDeBaja
                manejadorInputChange={handleInputChange}
                valor={id_motivo_baja}
                disabled={
                  props.esReactivacion
                    ? false
                    : ((afiliado?.id_motivo_baja !== null && afiliado?.id_motivo_baja > 0 && moment(afiliado?.fecha_baja).isValid()) || tabIngreso)
                }
                idPanel={props.idPanel}
                required={esMotivoBajaRequerido}
                validators={["motivoBajaValido"]}
                errorMessages={[
                  "Debe ingresar motivo de baja",
                ]}
              />
            </Grid>
          </Grid>
          <Grid container>

            {(id_parentesco === PARENTESCOS.MENOR_BAJO_GUARDA_O_TUTELA || id_parentesco === PARENTESCOS.FAMILIAR_A_CARGO || id_parentesco === PARENTESCOS.HIJO_CONYUGE || id_parentesco === PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE) && (
              <Grid item xs={2}>
                <TextValidator
                  margin="normal"
                  fullWidth
                  label="CUIL Familiar a cargo"
                  name="cuil_familiaracargo"
                  value={cuil_familiaracargo || ""}
                  autoComplete="off"
                  onChange={handleInputChange}
                  validators={[
                    // "required",
                    "isNumber",
                    "maxNumber:99999999999",
                    "minNumber:9999999999",
                    "isNotGrupoFamiliar",
                  ]}
                  errorMessages={[
                    // "Este campo es obligatorio",
                    "solo numeros",
                    "Verifique el cuil",
                    "Verifique el cuil",
                    "El cuil debe pertenecer al grupo familiar",
                  ]}
                />

              </Grid>
            )}
          </Grid>
          <Button id="btnsubmit" className={classes.hideButton} type="submit">
            Submit
          </Button>
        </div>
        {(id_tipo_afiliacion === TIPO_AFILIACION.TRASPASO ||
          id_tipo_afiliacion === TIPO_AFILIACION.TRASPASO_MR) &&
          id_parentesco === PARENTESCOS.TITULAR && (
            <Grid container spacing={1}>
              <Grid item xs={6} sm={6}>
                <BuscadorRnos
                  nroTraspaso={nro_traspaso}
                  rnos={rnos}
                  disabled={
                    props.esReactivacion
                      ? false
                      : props.idPanel === "idTabConsulta" ||
                        props.fromBandejaFamiliar ||
                        (props.fromBandeja && idAreaUsuario === areas.Nacional)
                        ? true
                        : false
                  }
                  handleInputChange={handleInputChange}
                  manejadorInputChange={(e) =>
                    setearValor("rnos", e.target.value)
                  }
                  fromBandeja={props.fromBandeja}
                />
              </Grid>
            </Grid>
          )}

        <Grid className={classes.botonera} container spacing={3}>
          <Grid item xs={6}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              {tabAfiliacion && (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleSaveClick(props.idPanel)}
                  className={classes.button}
                  startIcon={<Save />}
                >
                  GUARDAR
                </Button>
              )}
              {props.esReactivacion && (
                <>
                  {" "}
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleSaveClick(props.idPanel)}
                    className={classes.button}
                    startIcon={<Save />}
                  >
                    GUARDAR
                  </Button>
                </>
              )}
              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={() => {
                  props.openModalCredenciales();
                }}
                className={classes.button}
                startIcon={<CreditCard />}
              >
                VER CREDENCIALES
              </Button>
              {!sinFichaAfiliacion && (<Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleClickImprimirConstancia}
                className={classes.button}
                startIcon={<Print />}
              >
                IMPRIMIR CONSTANCIA
              </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
});
